import {createActionThunk} from 'redux-thunk-actions';
import AT from '../actionTypes';
import * as API from '../../services/api.services';

export const clinicProviderPlanLoadInit = createActionThunk(
    AT.CLINIC_PLAN_LOAD_INIT,
    (patient_id) => API.clinicProviderPlanLoadInit(patient_id),
);
